import { ReactNode } from 'react';

import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives/responsive';
import { N0 } from '@atlaskit/theme/colors';

export const ModalOverlay = ({ children }: { children: ReactNode }) => {
	return (
		<div css={positioningFrameCss}>
			<div css={modalOverlayCss}>
				<div css={contentCss}>
					<div css={primaryCss}>{children}</div>
				</div>
			</div>
		</div>
	);
};

const positioningFrameCss = css({
	display: 'flex',
	justifyContent: 'center',
	minHeight: '100vh',
	width: '100vw',
	[media.above.sm]: {
		alignItems: 'center',
		padding: 50,
	},
});

const modalOverlayCss = css({
	position: 'relative',
	display: 'flex',
	flexDirection: 'column',
	gap: 60,
	padding: 30,
	[media.above.sm]: {
		backgroundColor: N0,
		borderRadius: 4,
		padding: 50,
	},
	[media.below.md]: {
		maxWidth: '100%',
	},
	[media.above.md]: {
		width: '100%',
		maxWidth: 888,
		minHeight: 521,
		maxHeight: 521,
		justifyContent: 'center',
	},
});

const fontSize = {
	xs: '0.75rem', // 12px
	sm: '0.875rem', // 14px
	md: '1rem', // 16px
	lg: '1.25rem', // 20px
	xl: '2.25rem', // 36px
};

const contentCss = css({
	display: 'flex',
	justifyContent: 'center',
	fontFamily: 'var(--atlassian-recommended-system-fonts)',
	fontSize: fontSize.sm,
	gap: 50,
	maxWidth: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	h1: {
		fontSize: fontSize.xl,
		fontWeight: 500,
		lineHeight: 1.15,
		margin: 0,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	h2: {
		fontSize: 'inherit',
		fontWeight: 'normal',
		lineHeight: 1.25,
		margin: '.5rem 0 1.25rem',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'h1, h2': {
		textAlign: 'center',
	},
});

const primaryCss = css({
	maxWidth: '100%',
});
